export enum PayPeriodType {
  current = 'current',
  grace = 'grace',
  close = 'close',
}
